/**
 * Display helper for fields that may be a string OR an array of strings.
 * - null/undefined/empty → "—"
 * - array → comma-joined non-empty values, or "—" if all empty
 * - string → as-is, or "—" if blank
 *
 * Used by print/preview documents so multi-select fields render naturally.
 */
export function displayValue(value, placeholder = '—') {
  if (value === null || value === undefined) return placeholder;
  if (Array.isArray(value)) {
    const parts = value
      .filter((v) => v !== null && v !== undefined && String(v).trim() !== '')
      .map((v) => String(v).trim());
    return parts.length ? parts.join(', ') : placeholder;
  }
  const s = String(value).trim();
  return s || placeholder;
}
